import { Box, Text } from '@factorialco/deprecated-design-system'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import { Amount } from 'modules/finance/components/JournalsEntry/Datatable/_Amount'
import {
  ReconciliationItem,
  ReconciliationSource,
} from 'modules/finance/components/ReconciliationForm/types'

interface SummaryTotalsRowProps {
  reconciliations: ReconciliationItem[]
  source?: ReconciliationSource
}

export const SummaryTotalsRow = ({ reconciliations, source }: SummaryTotalsRowProps) => {
  const currency = source?.currency ?? ''

  const creditTotalAmountCents = useUnsafeMemo(() => {
    const reconciliationsCredit = reconciliations.reduce((acc, el) => {
      return acc + (el.creditCentsToReconcile || 0)
    }, 0)
    return reconciliationsCredit + (source?.creditCentsToReconcile || 0)
  }, [reconciliations, source])

  const debitTotalAmountCents = useUnsafeMemo(() => {
    const reconciliationsDebit = reconciliations.reduce((acc, el) => {
      return acc + (el.debitCentsToReconcile || 0)
    }, 0)
    return reconciliationsDebit + (source?.debitCentsToReconcile || 0)
  }, [reconciliations, source])

  return (
    <Box
      width="full"
      flexDirection="row"
      alignItems="center"
      justifyContent="spaceBetween"
      style={{ minHeight: '20px' }}
    >
      <Box flexDirection="row" gap="s48">
        <Text.Normal size="200" weight="medium" color="grey1000">
          {i18n.t('finance.reconciliations.total_summary.totals')}
        </Text.Normal>
      </Box>
      <Box flexDirection="row" justifyContent="spaceBetween" width="s240" paddingRight="s40">
        <Box textAlign="right" width="s120" justifyContent="center">
          <Amount amountCents={debitTotalAmountCents} currency={currency} />
        </Box>
        <Box textAlign="right" width="s120" justifyContent="center">
          <Amount amountCents={creditTotalAmountCents} currency={currency} />
        </Box>
      </Box>
    </Box>
  )
}
